import { DispatchFunction } from '../../models';
import { GET_API_EXPLORER_DOCUMENTATION } from '../constants';
import { Dispatch } from 'redux';
import { apiExplorerService } from '../../services';
import { AxiosResponse } from 'axios';
import { loadingData } from './basic.actions';

export function handleGetApiExplorerDocumentation(): DispatchFunction {

    return ((dispatch: Dispatch) => {
        dispatch(loadingData(true));
        apiExplorerService.getApiDocumentation()
            .then((response: AxiosResponse) => {
                let result: any = {};

                const responseDoc = new DOMParser().parseFromString(response.data, 'application/xml');
                if (responseDoc.childNodes.length) {
                    apiExplorerService.parseNode(responseDoc.childNodes[0], result);
                }
                const ds = result['edmx:Edmx']['edmx:DataServices'];

                if (ds.Schema.length) {
                    const schema = apiExplorerService.parseSchema(ds.Schema);
                    dispatch(getApiExplorerDocumentation(schema));
                }
            })
            .then(() => dispatch(loadingData(false)));
    });
}

export function getApiExplorerDocumentation(apiDocumentation: object) {
    return {
        payload: apiDocumentation,
        type: GET_API_EXPLORER_DOCUMENTATION
    };
}